export enum JobStatus {
  PENDING = "PENDING",
  RUNNING = "RUNNING",
  COMPLETED = "COMPLETED",
  ERROR = "ERROR"
}

export interface JobTypeStats {
  total_jobs: number
  completed_jobs: number
  error_count: number
  success_rate: number
  avg_duration_ms: number
}

export interface MonthlyStats {
  sync_bills: JobTypeStats
  process_bills: JobTypeStats
  monitor_bills: JobTypeStats
}

export interface RecentJob {
  job_id: string
  process_name: string
  status: JobStatus
  user_id: string
  duration_ms?: number
  created_at: string
}

export interface RecentJobsResponse {
  items: RecentJob[]
  total_count: number
}

export interface CreateJobResponse {
  job_id: string
}